import React from 'react';
import getConfig from 'next/config';
import styled from 'styled-components';

import Router from 'next/router';
import {
  Modal,
  // $FlowFixMe
} from '@bijie/react-bnb';

import { AUTH_TYPE } from '../../config/constantNg';
// eslint-disable-next-line import/no-cycle
import { gwPost } from '../actionsFactory/gwRequest';
import createBaseActions, { setPostBody } from '../actionsFactory';
import API_PATH from '../actionsFactory/apiPath';
import actionTypes from '../actionsFactory/types';
import { createCookie, eraseCookie } from '../../utils/cookies-browser';
import { getLabel } from '../../utils/i18n';
// eslint-disable-next-line import/no-cycle
import bridge from '../../utils/withBridge';
import {
  getUrlParam, getLoginUrl, checkCallback, pushLoginPage,
} from '../../utils/urlUtils';
import wfp from '../../utils/wfp';
import urls from '../../config/urls/index';

const { BOTH, GOOGLE, SMS } = AUTH_TYPE;

const { USER_STATE_LOGGED_OUT, USER_STATE_LOGGED_IN } = actionTypes;

const { LOGIN_API_PATH, USER_LOGIN_OUT_API } = API_PATH;

const {
  publicRuntimeConfig: {
    assetPrefix,
  },
} = getConfig();

const getCallback = (url, referer) => {
  if (!checkCallback(url)) {
    return '';
  }
  return referer ? `${url}&zendesk=${referer}` : url;
};

export const userLoggedOut = createBaseActions(USER_STATE_LOGGED_OUT);
export const userLoggedIn = createBaseActions(USER_STATE_LOGGED_IN);

export const Logout = async (ev, locale) => {
  ev && ev.preventDefault();
  const result = await gwPost(USER_LOGIN_OUT_API);
  if (result.success) {
    eraseCookie('logined');
    eraseCookie('cr00');
    eraseCookie('JSESSIONID');
    eraseCookie('p20t');
    eraseCookie('mobile');
    Router.push(getLoginUrl(locale));
  }
};

const Title = styled.p`
  font-size: 16px;
`;

const DescItem = styled.p`
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  margin-top: 14px !important;
`;

const _loginCallback = (res, email, locale, i18n, dispatch) => {
  const {
    success, data, message, code,
  } = res;
  const callbackUrl = getUrlParam('callback');
  const callbackReferer = getUrlParam('zendesk');
  const callback = callbackUrl ? getCallback(callbackUrl, callbackReferer) : '';

  if (success) {
    const {
      currentDeviceId,
      gauth,
      mobileSecurity,
      disable,
      mobile,
    } = data;
    if (disable) {
      Modal.info({
        icon: <img src={assetPrefix + require('../../static/images/2fa/account-frozen.svg')} alt="account frozen" />,
        content: (
          <>
            <Title>{getLabel('exchange-login-accountDisable', i18n)}</Title>
            <DescItem>{getLabel('usExchange-account-disabled-content', i18n)}</DescItem>
          </>
        ),
        onOk: () => { window.open(urls.external.supportRequest); },
        okText: getLabel('usExchange-account-disabled-submit-button', i18n),
      });
      return;
    }

    let authType = '';
    if (gauth && !mobileSecurity) {
      authType = GOOGLE;
    }

    if (!gauth && mobileSecurity) {
      authType = SMS;
      sessionStorage.setItem('userMobile', mobile);
    }

    if (gauth && mobileSecurity) {
      authType = BOTH;
      sessionStorage.setItem('userMobile', mobile);
    }
    if (authType) {
      sessionStorage.setItem('email', email);
      Router.pushRoute(
        `/${locale}/authenticate/${authType}${callback ? `?callback=${callback}` : ''}`
      );
      return;
    }
    createCookie('logined', 'y', 7, true);
    dispatch(userLoggedIn());
    wfp.saveCurrentDeviceId(email, currentDeviceId || '');
    if (callback) {
      window.location.href = callback;
      return;
    }
    if (!callback) {
      Router.push(`/${locale}/usercenter/dashboard/overview`);
      return;
    }
  }
  if (code === '200001005') {
    sessionStorage.setItem('registerEmail', email);
    Router.pushRoute(`/${locale}/email-verification`);
    return;
  }

  if (code === '006007') {
    pushLoginPage(locale);
    return;
  }

  if (code === '200002040') {
    return;
  }

  Modal.info({
    icon: <img src={assetPrefix + require('./error.svg')} width="78" alt="error" />,
    content: <p>{message}</p>,
    okText: getLabel('exchange-modal-iUnderstood', i18n),
  });
};

export const login = formData => async (dispatch, getState) => {
  const { locale, localeData } = getState();
  const i18n = localeData[locale];
  try {
    const { email } = formData;
    const result = await gwPost(LOGIN_API_PATH, formData);
    _loginCallback(result, email, locale, i18n, dispatch);
    return result;
  } catch (error) {
    throw error;
  }
};

export const auth = async () => gwPost(API_PATH.USER_VERIFY_TOKEN);

const checkLogged = async () => bridge.isLogged();

export const verifyToken = () => async dispatch => {
  let isLogined = false;
  try {
    const data = await checkLogged();
    if (!data.logged) throw new Error();
    isLogined = true;
    dispatch({ type: USER_STATE_LOGGED_IN });
  } catch (error) {
    dispatch({ type: USER_STATE_LOGGED_OUT });
  }
  return isLogined;
};
export default Logout;
